import React from 'react'
import styled from 'styled-components'

import Angle from '../atoms/Angle'
import Image from '../atoms/Image'
import OuterLink from '../atoms/OuterLink'

const Container = styled.div`
  border: 1px solid ${({ theme }) => theme.palette.border.light};
  border-radius: 3px;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.15);
  padding: 7px 3px 7px 8px;
  @media (min-width: ${({ theme }) => theme.mediaQuery.desktop.minWidth}) {
    box-shadow: none;
    padding: 5px 10px 5px 15px;
  }
`

const Link = styled(OuterLink)`
  align-items: center;
  display: flex;
  position: relative;
  text-decoration: none;
`

const LinkImage = styled.div`
  object-fit: cover;
  margin-right: 8px;
  width: 24px;
  height: 24px;
  @media (min-width: ${({ theme }) => theme.mediaQuery.desktop.minWidth}) {
    display: none;
  }
`

const LinkText = styled.span`
  color: ${({ theme }) => theme.palette.font.link};
  flex: 1;
  font-size: 10px;
  @media (min-width: ${({ theme }) => theme.mediaQuery.desktop.minWidth}) {
    font-size: 13px;
  }
`

const LinkAngle = styled(Angle)`
  width: 24px;
  height: 24px;
  margin-right: auto;
`

type Props = {
  className?: string
  image?: string
  text: string
  to: string
}

export default function Announcement({ className, image, text, to }: Props) {
  return (
    <Container className={className}>
      <Link to={to}>
        {image && (
          <LinkImage>
            <Image filename={image} />
          </LinkImage>
        )}
        <LinkText>{text}</LinkText>
        <LinkAngle color="pink" direction="right" />
      </Link>
    </Container>
  )
}
